import FulfillmentModal from "./FulfillmentModal";
export default FulfillmentModal;
